import React, { useEffect, useState } from 'react';
import Button from '../../../component/ui/Button';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Table from '../../../component/table/Table';
import sortbydot from '../../../assets/image/sort_by_group.svg';
import dateRange from '../../../assets/image/date_range.svg';
import moment from 'moment';
import Modal from '../../../component/modal/Modal';
import CustumDateSelect from './CustumDateSelect';
import Pagination from '../../../component/pagination';
import { fetchInventoryAdjustmentList } from '../../../services/adjustments';
import { getDate } from '../../../utils/dateUtils';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import { useSelector } from 'react-redux';
import { hasPermission } from '../../../utils/controller';
import DataNotFound from '../../components/dataNotFound';
import { getFilterType } from '../../../utils/utility';

const sortIconMap = {
	asc: <IoIosArrowRoundUp />,
	desc: <IoIosArrowRoundDown />,
};

const InventoryAdjustment = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const suburl = localStorage.getItem('suburl');
	const [showCustomDatePicker, setShowCustomDatePicker] = useState(false);
	const [showCustomDate, setShowCustomDate] = useState(false);
	const [totalPages, setTotalPages] = useState(0);
	const [headerDropDown, setHeaderDropDown] = useState('All');
	const [customDates, setCustomDates] = useState({
		startDate: new Date(),
		endDate: new Date(),
		key: 'selection',
	});
	const [sortDirection, setSortDirection] = useState({});
	const [tableData, setTableData] = useState([]);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const navigateRouter = (path) => {
		navigate(path);
	};

	const [params, setParams] = useState(() => ({
		page: Number(searchParams.get("page")) || 1,
		pageSize: Number(searchParams.get("pageSize")) || 10,
		orderBy: searchParams.get("orderBy") || "",
		sortBy: searchParams.get("sortBy") || "",
		filterType: searchParams.get("filterType") || 'All',
		filterBy: searchParams.get("filterBy") || "",
		filterValue:
			getFilterType(searchParams.get("filterType")) === 'All' ? '' : {
				startDate: searchParams.get("startDate") || "",
				endDate: searchParams.get("endDate") || "",
			},
	}));


	const inventoryAdjustmentTableColoum = [
		{
			field: 'DATE',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 93,
			flex: 1,
			headerComponent: () => (
				<div
					className="header-clickable w-100 w-100"
					onClick={() => sortData({ sortBy: 'asc', orderBy: 'date' })}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							Date
							<span className="sort-icon">{sortIconMap[sortDirection?.date]}</span>
						</p>
					</div>
				</div>
			),
		},
		{
			field: 'ACCOUNT',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 80,
			flex: 1,
			headerComponent: () => (
				<div
					className="header-clickable w-100"
					onClick={() => sortData({ sortBy: 'asc', orderBy: 'account' })}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							ACCOUNT
							<span className="sort-icon">{sortIconMap[sortDirection?.account]}</span>
						</p>
					</div>
				</div>
			),
		},
		{
			field: 'DESCRIPTON',
			headerClass: 'HeaderBg right-align',
			cellClass: 'right-align',
			suppressSizeToFit: true,
			minWidth: 100,
			flex: 1,
			headerComponent: () => (
				<div
					className="header-clickable w-100 header-right"
					onClick={() => sortData({ sortBy: 'asc', orderBy: 'description' })}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							DESCRIPTON
							<span className="sort-icon">{sortIconMap[sortDirection?.description]}</span>
						</p>
					</div>
				</div>
			),
		},
		{
			field: 'STATUS',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 88,
			flex: 1,
			headerComponent: () => (
				<div
					className="header-clickable w-100"
					onClick={() => sortData({ sortBy: 'asc', orderBy: 'status' })}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							STATUS
							<span className="sort-icon">{sortIconMap[sortDirection?.status]}</span>
						</p>
					</div>
				</div>
			),
		},
		{
			field: 'REFERENCE NUMBER',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 90,
			flex: 1,
			headerComponent: () => (
				<div
					className="header-clickable w-100"
					onClick={() => sortData({ sortBy: 'asc', orderBy: 'reference_number' })}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							<p className="d-none d-lg-block mb-0">REFERENCE NUMBER</p>
							<p className="d-block d-lg-none mb-0">REF. NO.</p>
							<span className="sort-icon">{sortIconMap[sortDirection?.reference_number]}</span>
						</p>
					</div>
				</div>
			),
		},
		{
			field: 'REASON',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 92,
			flex: 1,
			headerComponent: () => (
				<div
					className="header-clickable w-100"
					onClick={() => sortData({ sortBy: 'asc', orderBy: 'reason' })}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							REASON
							<span className="sort-icon">{sortIconMap[sortDirection?.reason]}</span>
						</p>
					</div>
				</div>
			),
		},
		{
			field: 'CREATED TIME',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 94,
			flex: 1,
			headerComponent: () => (
				<div
					className="header-clickable w-100"
					onClick={() => sortData({ sortBy: 'asc', orderBy: 'created_at' })}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							<p className="d-none d-lg-block mb-0">CREATED TIME</p>
							<p className="d-block d-lg-none mb-0">TIME</p>
							<span className="sort-icon">{sortIconMap[sortDirection?.created_at]}</span>
						</p>
					</div>
				</div>
			),
		},
	];

	const onRowClick = (id) => {
		if (id && hasPermission('inventory.adjustments.view', user?.role?.role_permissions)) {
			navigate(`/user/${suburl}/inventory-adjustment-crete/${id}`);
		}
	};

	const getDateRange = (filter) => {
		const today = moment().startOf('day');
		let fromDate, toDate;
		switch (filter) {
			case 'Today':
				fromDate = today;
				toDate = moment(fromDate).endOf('day');
				break;
			case 'week':
				fromDate = moment(today).startOf('isoWeek');
				toDate = moment(today).endOf('isoWeek');
				break;
			case 'month':
				fromDate = moment(today).startOf('month');
				toDate = moment(today).endOf('month');
				break;
			case 'quarter':
				fromDate = moment(today).startOf('quarter');
				toDate = moment(today).endOf('quarter');
				break;
			case 'year':
				fromDate = moment(today).startOf('year');
				toDate = moment(today).endOf('year');
				break;
			case 'fiscal':
				fromDate =
					moment(today).month() >= 3
						? moment(today).startOf('year').month(3).startOf('month')
						: moment(today).subtract(1, 'year').month(3).startOf('month');
				toDate = moment(fromDate).add(1, 'year').subtract(1, 'day');
				break;
			case 'custom':
				fromDate = customDates.startDate;
				toDate = customDates.endDate;
				break;
			default:
				fromDate = null;
				toDate = null;
				break;
		}
		return {
			fromDate: fromDate ? fromDate.format('YYYY-MM-DD') : null,
			toDate: toDate ? toDate.format('YYYY-MM-DD') : null,
		};
	};

	const setFilterParam = (data) => {
		setParams((prev) => ({
			...prev,
			filterType: 'custom',
			filterValue: data.filterValue,
			filterBy: data.filterBy
		}))
	}

	const filterData = (filter, data) => {
		setHeaderDropDown(data);
		if (filter === 'custom') {
			setShowCustomDate(true);
		} else {
			const { fromDate, toDate } = getDateRange(filter);
			setParams((prev) => ({
				...prev,
				filterType: filter,
				filterValue: {
					startDate: fromDate,
					endDate: toDate,
				},
				filterBy: 'date'
			}));
			setShowCustomDate(false);
		}
	};

	const handlePageChange = (page) => {
		setParams((prev) => ({
			...prev,
			page: page
		}))
	};
	const sortData = (param) => {
		const newDirection = sortDirection[param.orderBy] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.orderBy]: newDirection });
		setParams((prev) => ({
			...prev,
			orderBy: param.orderBy,
			sortBy: newDirection,
		}))
	};

	const getInventoryDetails = async () => {
		try {
			setLoading(true);
			const param = {
				page: params.page,
				pageSize: params.pageSize,
				orderBy: params.orderBy,
				sortBy: params.sortBy,
				filterType: params.filterType,
				filterBy: params.filterBy,

				...(params.filterType !== "All" && {
					filterValue: params.filterValue,
				}),
			};
			const res = await fetchInventoryAdjustmentList(param);
			if (res?.success) {
				const inventoryList = res?.data?.data;
				let Tdata = [];
				let FilterData = inventoryList?.inventoryAdjustment?.filter((item) => {
					return item?.is_deleted === 0 && item?.is_draft !== 2;
				});
				FilterData?.forEach((data) => {
					Tdata.push({
						id: data?.adjustment_id,
						DATE: getDate(data?.date),
						REASON: data?.reason?.reason_description,
						DESCRIPTON: data?.description,
						STATUS: data?.is_draft === 0 ? "Draft" : "Converted",
						"REFERENCE NUMBER": data?.reference_number,
						ACCOUNT: data?.account?.account_name,
						"CREATED TIME": getDate(data?.created_at),
					});
				});

				setTableData(Tdata);
				let toatlPages = Math.ceil(res?.data?.data?.totalCount / params.pageSize);
				setTotalPages(toatlPages);

			} else {
				setTableData([]);
				setTotalPages(0);
			}
		} catch (err) {
			setTableData([]);
			setTotalPages(0)
		} finally {
			setLoading(false);
		}
	};

	const setFilterFromUrl = () => {
		setSortDirection({
			[searchParams.get("orderBy")]: searchParams.get("sortBy") || "",
		});
		setHeaderDropDown(getFilterType(searchParams.get("filterType")))
		if (searchParams.get("filterType") === 'custom') {
			setShowCustomDate(true);
			setCustomDates((prev) => ({
				...prev,
				startDate: new Date(searchParams.get("startDate")),
				endDate: new Date(searchParams.get("endDate")),
			}));
		}
	};

	useEffect(() => {
		const url = new URLSearchParams();
		url.set("page", params.page);
		url.set("pageSize", params.pageSize);
		url.set('orderBy', params.orderBy);
		url.set('sortBy', params.sortBy)
		url.set('filterType', params.filterType);
		url.set('filterBy', params.filterBy);
		if (getFilterType(params.filterType) !== 'All') {
			url.set("startDate", params.filterValue.startDate);
			url.set("endDate", params.filterValue.endDate);
		}
		setSearchParams(url)
	}, [params, setSearchParams]);

	useEffect(() => {
		setFilterFromUrl();
	}, []);

	useEffect(() => {
		getInventoryDetails();
	}, [params]);

	return (
		<div style={{ overflow: 'auto' }}>
			<div className="product-pg-header add-product">
				<div className="d-flex align-items-center gap-4">
					<div className="dropdown text-end">
						<a
							className="d-block link-dark text-decoration-none dropdown-toggle"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<p>{headerDropDown}</p>
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser1"
							style={{ minWidth: '240px' }}
						>
							<li>
								<a
									className="dropdown-item"
									onClick={() => filterData('', 'All')}
								>
									All
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => filterData('Today', 'Today')}
								>
									Today
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => filterData('week', 'This Week')}
								>
									This Week
								</a>
							</li>
							<li>
								<a
									href=""
									className="dropdown-item"
									onClick={() => filterData('month', 'This Month')}
								>
									This Month
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => filterData('quarter', 'This Quarter')}
								>
									This Quarter
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => filterData('year', 'This Year')}
								>
									This Year
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => filterData('fiscal', 'This Fiscal Year')}
								>
									This Fiscal Year
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => filterData('custom', 'Custom Date')}
								>
									Custom Date
								</a>
							</li>
						</ul>
						{showCustomDatePicker && (
							<div>
								<Modal
									className="custom-date-model"
									isOpen={showCustomDatePicker}
									onClose={() => setShowCustomDatePicker(false)}
									title="Select Custom Date"
								>
									<CustumDateSelect
										isOpen={showCustomDatePicker}
										onCLose={() => setShowCustomDatePicker(false)}
										reloadTable={''}
										setFilterparam={setFilterParam}
										setCustomDates={setCustomDates}
										customDates={customDates}
									/>
								</Modal>
							</div>
						)}
					</div>
					{showCustomDate && (
						<button
							onClick={() => setShowCustomDatePicker(!showCustomDatePicker)}
							style={{
								padding: '5px 10px',
								borderRadius: '6px',
								border: '1px solid #ccc',
								backgroundColor: '#f9f9f9',
								cursor: 'pointer',
							}}
							className="mx-2"
						>
							<div>
								<img
									src={dateRange}
									alt="Date"
									width={20}
									height={20}
								/>
								<span className="text-dark mx-4">
									{customDates.startDate !== null && customDates.endDate !== null
										? `${getDate(customDates.startDate)} - ${getDate(customDates.endDate)}`
										: 'Select Custom Date'}
								</span>
							</div>
						</button>
					)}
				</div>

				<div className="add-product-button column-gap-0">
					<Button
						type="button"
						className="btn-primary mt-0 px-5"
						button="Create New Adjustment"
						disabled={!hasPermission('inventory.adjustments.create', user?.role?.role_permissions)}
						add
						onClick={() => navigateRouter(`/user/${suburl}/inventory-adjustment-crete`)}
					/>
					<div className="dropdown text-end ms-3">
						<a
							href="#"
							className="d-block link-dark text-decoration-none"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<img src={sortbydot} alt='arrow' />
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser1"
							style={{ minWidth: '240px' }}
						>
							<li>
								<a className="dropdown-item sortBy">Sort By</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortData({ sortBy: 'asc', orderBy: 'date' })}
								>
									Date
									<span>{sortIconMap[sortDirection?.date]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortData({ sortBy: 'asc', orderBy: 'reason' })}
								>
									Reason
									<span>{sortIconMap[sortDirection?.reason]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortData({ sortBy: 'asc', orderBy: 'created_at' })}
								>
									Created Time
									<span>{sortIconMap[sortDirection?.created_at]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortData({ sortBy: 'asc', orderBy: 'description' })}
								>
									Description
									<span>{sortIconMap[sortDirection?.description]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortData({ sortBy: 'asc', orderBy: 'status' })}
								>
									Status
									<span>{sortIconMap[sortDirection?.status]}</span>
								</a>
							</li>
							<li>
								<a
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
									className="dropdown-item"
									onClick={() => sortData({ sortBy: 'asc', orderBy: 'reference_number' })}
								>
									Reference Number
									<span>{sortIconMap[sortDirection?.reference_number]}</span>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>

			{loading ? (
				<div
					className="d-flex justify-content-center align-items-center"
					style={{ height: '100%', marginTop: '20%' }}
				>
					<span
						className="Page_loader"
						role="status"
						aria-hidden="true"
					></span>
				</div>
			) : tableData.length > 0 ? (
				<div className="productTable-body">
					<Table
						row={tableData}
						coloum={inventoryAdjustmentTableColoum}
						className="productTable"
						onRowClick={onRowClick}
						style={{ height: 'calc(100vh - 148px)' }}
					/>
				</div>
			) : (
				<DataNotFound
					title={'Keep your inventory accurate!'}
					subtitle={'Instantly balance your stock records.'}
					descriptionTitle={'Stay precise!'}
					descriptionSubTitle={'Update your stock levels and ensure every item count '}
					descriptionContent={'is correct — all in one place.'}
					buttonText={'Create New Adjustment'}
					disabled={!hasPermission('inventory.adjustments.create', user?.role?.role_permissions)}
					onClick={() => navigateRouter(`/user/${suburl}/inventory-adjustment-crete`)}
				/>
			)}
			{tableData.length > 0 && (
				<Pagination
					currentPage={params.page}
					totalPages={totalPages}
					onChangePage={handlePageChange}
					pageSize={params.pageSize}
					setParam={(value) => {
						setParams((prev) => ({
							...prev,
							pageSize: value,
							page: 1,
						}))
					}}
				/>
			)}
		</div>
	);
};

export default InventoryAdjustment;
